import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { config } from '../../../../config/config';
import readXlsxFile from 'read-excel-file';

import { BaseComponent } from '../base.component';
import { SuccessWrapComponent } from '../success.wrap/success.wrap.component';

@Component({
  selector: 'ig-file-selector',
  templateUrl: './file.selector.component.html',
  styleUrls: ['./file.selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FileSelectorComponent extends BaseComponent implements OnInit {
  @Input() public sizeLimit = config.eventImageSizeLimit;
  @Input() public command: any;
  @Input() public selectedImageData: string;
  @Input() public isSmallIcon: boolean;
  @Input() public disabled: boolean;
  @Input() public multiple: boolean = false;
  @Input() public accept: string =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
  @ViewChild('imageSelector') public imageSelector: ElementRef;
  @Output() public onRead = new EventEmitter<any>();
  @ViewChild('upload') public uploadImageSuccess: SuccessWrapComponent;
  public isShowUploadingSpinner = false;

  public separator = ',';

  constructor() {
    super();
  }

  public ngOnInit() {}

  public records: any[] = [];
  @ViewChild('csvReader') csvReader: any;

  uploadListener($event: any): void {
    let files = $event.srcElement.files;

    console.log('files', files);

    // for uploading csv events
    if (!this.multiple && files[0].type.includes('officedocument.spreadsheet')) {
      readXlsxFile(files[0]).then((rows) => {
        // `rows` is an array of rows
        // each row being an array of cells.
        this.onRead.emit(rows);
      });
    } else {
      this.onRead.emit(files);
    }

    return;

    // if (this.isValidCSVFile(files[0])) {
    //
    //     let input = $event.target;
    //     let reader = new FileReader();
    //     reader.readAsText(input.files[0]);
    //
    //     reader.onload = () => {
    //         let csvData = reader.result;
    //         let result = this.csvToJSON(csvData);
    //         // let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
    //         //
    //         //let headersRow = this.getHeaderArray(csvRecordsArray);
    //         //
    //         // this.records = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
    //         this.onRead.emit(result);
    //     };
    //
    //     reader.onerror = function () {
    //         console.log('error is occured while reading file!');
    //     };
    //
    // } else {
    //     alert("Please import valid .csv file.");
    //     this.fileReset();
    // }
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = (<string>csvRecordsArray[i]).split(',');
      if (curruntRecord.length == headerLength) {
        let csvRecord: CSVRecord = new CSVRecord();
        csvRecord.content1 = curruntRecord[0].trim();
        csvRecord.content2 = curruntRecord[1].trim();
        csvRecord.content3 = curruntRecord[2].trim();
        csvArr.push(csvRecord);
      }
    }
    return csvArr;
  }

  isValidCSVFile(file: any) {
    return file.name.endsWith('.csv');
  }

  getHeaderArray(csvRecordsArr: any) {
    let headers = (<string>csvRecordsArr[0]).split(',');
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }

  csvToJSON(content) {
    let lines = content.split('\n');
    let result = [];
    let start = 0;
    let columnCount = lines[0].split(this.separator).length;

    let headers = [];
    //if (content.header) {
    headers = lines[0].split(this.separator);
    start = 1;
    //}

    for (let i = start; i < lines.length; i++) {
      let obj = {};
      let currentline = lines[i].split(new RegExp(this.separator + '(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
      if (currentline.length === columnCount) {
        //if (content.header) {
        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }
      } else {
        for (let k = 0; k < currentline.length; k++) {
          obj[k] = currentline[k];
        }
        result.push(obj);
      }
    }
    return result;
  }

  fileReset() {
    this.csvReader.nativeElement.value = '';
    this.records = [];
  }

  public showSpinner() {
    this.isShowUploadingSpinner = true;
  }

  public hideSpinner() {
    this.isShowUploadingSpinner = false;
  }
}

export class CSVRecord {
  public content1: any;
  public content2: any;
  public content3: any;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/file.selector/file.selector.component.ts